import { RoutesCommon as COMMON } from './routes-common.model';
import { RoutesSettings as SETTINGS } from './routes-settings.model';
import { RoutesNotifications as NOTIFICATIONS } from './routes-notifications.model';
import { RoutesHome as HOME } from './routes-home.model';
import { RoutesServices as SERVICES } from './routes-services.model';

const routes = {
  COMMON,
  SETTINGS,
  NOTIFICATIONS,
  HOME,
  SERVICES,
};

export function RoutePaths() {
  return routes;
}
